import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment } from '@angular/router';
import { AuthenticatorService } from '../Services/authenticator.service';
import { PingService } from '../Services/ping.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class isPasswordGuard {
    constructor(
        private router: Router,
        private auth: AuthenticatorService,
        private pingService: PingService,
        private snackBar: MatSnackBar
    ) {}

    async canLoad(): Promise<boolean> {
        const backend = await this.pingService.makePing();

        if (backend) {
            if (await this.auth.isLoggedByTokenRestorePassword()) {
                return true;
            } else {
                this.router.navigate(['/login']);
                return false;
            }
        } else {
            return false;
        }
    }

    async canActivate(): Promise<boolean> {
        const backend = await this.pingService.makePing();

        if (backend) {
            // const token: string | undefined =
            //     await this.pingService.recaptchaV3('guardAction');
            // const recaptcha = token
            //     ? await this.pingService.validateRecapchaV3(token)
            //     : true;

            const recaptcha = true;
            
            if (recaptcha) {
                if (await this.auth.isLoggedByTokenRestorePassword()) {
                    return true;
                } else {
                    this.router.navigate(['/login']);
                    return false;
                }
            } else {
                return false;
            }
        } else {
            // this.snackBar.open(
            //     'Tráfico inusual procedente de tu red de computadoras',
            //     '🤖',
            //     {
            //         duration: 3000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'right',
            //         panelClass: ['snack-error-message'],
            //     }
            // );
            return false;
        }
    }
}
